/**
 * 탭 끌어서 순서 바꾸기 (2026-10-01).
 *
 * `openFiles` 한 배열에 **모든 프로젝트의 탭이 섞여** 있고, 탭 줄은 그중 활성 프로젝트의 것만 거른 것이다.
 * 그래서 다른 프로젝트의 탭 사이로 옮기면 안 된다 — 놓은 자리의 탭이 다른 프로젝트면 아무것도 하지 않는다.
 * 같은 프로젝트끼리는 전체 배열에서 「놓은 탭 바로 앞/뒤」 로 옮기면 거른 순서도 그대로 맞는다.
 */
export function reorderTabs(files, dragId, targetId, before) {
    if (!Array.isArray(files) || dragId === targetId) return files;
    const drag = files.find(f => f.id === dragId);
    const target = files.find(f => f.id === targetId);
    if (!drag || !target) return files;
    if ((drag.projectId || null) !== (target.projectId || null)) return files;
    const rest = files.filter(f => f.id !== dragId);
    const at = rest.findIndex(f => f.id === targetId) + (before ? 0 : 1);
    const next = [...rest.slice(0, at), drag, ...rest.slice(at)];
    // 탭 줄에서 보이는 순서가 그대로면 같은 배열 — 쓸데없는 렌더·자동 저장을 만들지 않는다
    const pid = drag.projectId || null;
    const row = (arr) => arr.filter(f => (f.projectId || null) === pid).map(f => f.id).join('\u0000');
    return row(next) === row(files) ? files : next;
}
